/* eslint-disable @typescript-eslint/no-explicit-any */
import { QuestionOutput, QuestionType } from '@/api/gql/graphql';
import { createMenuItem } from '@/components/Common/DropdownMenu/MenuDropdown.utils';
import { useHandleQuizzForm } from '@/hooks/useQuizzForm';
import { useParams } from 'react-router-dom';
import { useQuestionLogic } from '@/hooks/useQuestionLogic';
import { useGeneratedQuizStore } from '@/store/GeneratedDataStore/GeneratedQuizStore';
import { useState } from 'react';

export type QuizFormMode = 'create' | 'update';

export const useGeneratedQuizz = () => {
  const {
    openGeneratedQuizzModal,
    setGeneratedInitialSelectedOptions,
    generatedInitialSelectedOptions,
    selectedGeneratedQuizz,
    setSelectedGeneratedQuizz,
    generatedFormMode,
    setGeneratedFormMode,
  } = useGeneratedQuizStore();

  // État local pour gérer la modal de suppression
  const [isOpenQuizDeleteModal, setIsOpenQuizDeleteModal] = useState(false);
  const [isDeletePending] = useState(false);

  const openQuizDeleteModal = () => {
    setIsOpenQuizDeleteModal(!isOpenQuizDeleteModal);
  };

  const { lessonId } = useParams();

  const {
    register: registerUpdate,
    handleSubmit: handleSubmitUpdate,
    errors: updateErrors,
    setValue: setUpdateValue,
    reset: resetUpdate,
  } = useHandleQuizzForm('update');

  const {
    selectedType,
    setSelectedType,
    response1Check,
    setResponse1Check,
    response2Check,
    setResponse2Check,
    response3Check,
    setResponse3Check,
    response4Check,
    setResponse4Check,
  } = useQuestionLogic();

  const QuizzQuestionType = [
    { _id: QuestionType.Qcm, name: QuestionType.Qcm },
    { _id: QuestionType.TrueOrFalse, name: QuestionType.TrueOrFalse },
    { _id: QuestionType.MissingWords, name: QuestionType.MissingWords },
  ];

  const handleSelectedQuizz = (quizz: QuestionOutput) => {
    setSelectedGeneratedQuizz(quizz);
  };

  const handleFormMode = (item: QuestionOutput) => {
    setSelectedGeneratedQuizz(item);
    setGeneratedFormMode('update');
  };

  const handleDeleteQuizz = (item: QuestionOutput) => {
    setSelectedGeneratedQuizz(item);
    openQuizDeleteModal();
  };

  const quizzMenuItems = (item: QuestionOutput) => [
    createMenuItem('Modifier', '', () => handleFormMode(item)),
    createMenuItem('Supprimer', 'text-[#EA242C]', () =>
      handleDeleteQuizz(item),
    ),
  ];

  return {
    lessonId,
    openGeneratedQuizzModal,
    handleSelectedQuizz,
    setSelectedGeneratedQuizz,
    selectedGeneratedQuizz,
    QuizzQuestionType,
    quizzMenuItems,
    registerUpdate,
    handleSubmitUpdate,
    setUpdateValue,
    updateErrors,
    resetUpdate,
    handleSelectedType: setSelectedType,
    selectedType,
    response1Check,
    setResponse1Check,
    response2Check,
    setResponse2Check,
    response3Check,
    setResponse3Check,
    response4Check,
    setResponse4Check,
    isDeletePending,
    isOpenQuizDeleteModal,
    openQuizDeleteModal,
    generatedFormMode,
    setGeneratedFormMode,
    generatedInitialSelectedOptions,
    setGeneratedInitialSelectedOptions,
  };
};
